import {
  ActionType,
  IVerifyPhoneNumberPayload,
  IVerifyPhoneNumberResponse,
} from "models/setting/verifyPhoneNumber";

export const verifyPhoneNumberAction = (payload: IVerifyPhoneNumberPayload) => {
  return {
    type: ActionType.VERIFY_PHONE_NUMBER,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.VERIFY_PHONE_NUMBER_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IVerifyPhoneNumberResponse) => {
  return {
    type: ActionType.VERIFY_PHONE_NUMBER_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.VERIFY_PHONE_NUMBER_RESET,
  };
};
